import { useSidebarPermission } from "../Context/SidebarPermissionContext";

// Helper function to determine if permission is granted
export const HasPermission = (permissionName) => {
    const { permissions } = useSidebarPermission();
    const permission = permissions != undefined && permissions.length > 0 && permissions.find(p => p.permission === permissionName);
    return permission ? permission.allow : false;
}

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};


export const formatDate = (inputDate) => {
    if (inputDate == null || inputDate == "") {
        return ""
    }
    const date = new Date(inputDate);

    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();

    const formattedDate = `${month}/${day}/${year}`;

    return formattedDate;
}
export const formatDateTime = (inputDate) => {
    if (inputDate == null || inputDate === "") {
        return "";
    }
    const date = new Date(inputDate);

    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    let currentTime = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
    const formattedDate = `${month}/${day}/${year}`+' '+currentTime;
    return formattedDate;
};
